(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bershk-drop"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bkd').forEach(function(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var form=root.querySelector('.bkd-form');
    var hidden=root.querySelector('[data-bkd-id]');
    var price=root.querySelector('[data-bkd-price]');
    var bar=root.querySelector('[data-bkd-barprice]');
    root.querySelectorAll('.bkd-size').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.hasAttribute('disabled'))return;
        root.querySelectorAll('.bkd-size').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
        if(hidden)hidden.value=b.dataset.id;
        if(price&&b.dataset.price)price.textContent=b.dataset.price;
        if(bar&&b.dataset.price)bar.textContent=b.dataset.price;
      });
    });
    var buy=root.querySelector('[data-bkd-buy]');
    if(buy&&form)buy.addEventListener('click',function(){form.requestSubmit?form.requestSubmit():form.submit();});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bershk-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function rotate(container, imgSelector, delay){
    var imgs = container.querySelectorAll(imgSelector);
    if (imgs.length < 2) return;
    var idx = 0;
    setInterval(function(){
      imgs[idx].classList.remove('on');
      idx = (idx + 1) % imgs.length;
      imgs[idx].classList.add('on');
    }, delay);
  }

  document.querySelectorAll('.bkl').forEach(function(root){
    if(root.dataset.ready) return; root.dataset.ready='1';

    // --- Rotación automática del hero ---
    var hero = root.querySelector('[data-bkl-hero]');
    if (hero) {
      var heroDelay = parseInt(hero.dataset.delay, 10) || 1000;
      rotate(hero, '[data-bkl-slide]', heroDelay);
    }

    // --- Rotación de la foto del pack (slot único) ---
    root.querySelectorAll('[data-bkl-media]').forEach(function(slot){
      var mediaDelay = parseInt(slot.dataset.delay, 10) || 3000;
      rotate(slot, '[data-bkl-media-img]', mediaDelay);
    });

    // --- Formulario de compra / tallas ---
    var form = root.querySelector('.bkl-form');
    var hidden = root.querySelector('[data-bkl-id]');
    var price = root.querySelector('[data-bkl-price]');
    var addBtn = root.querySelector('[data-bkl-add-btn]');
    var btnLabel = root.querySelector('[data-bkl-btn-label]');
    var sizesBlock = root.querySelector('[data-bkl-sizes-block]');
    var sizeButtons = root.querySelectorAll('.bkl-size');
    var hasSizes = sizeButtons.length > 0;

    sizeButtons.forEach(function(b){
      b.addEventListener('click',function(){
        if(b.hasAttribute('disabled'))return;
        sizeButtons.forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
        if(hidden)hidden.value=b.dataset.id;
        if(price&&b.dataset.price)price.textContent=b.dataset.price;
      });
    });

    // --- Acordeón de beneficios ---
    root.querySelectorAll('[data-bkl-ben-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.bkl-ben');
        var body = item.querySelector('[data-bkl-ben-body]');
        var isOpen = item.classList.contains('is-open');

        root.querySelectorAll('.bkl-ben.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('[data-bkl-ben-body]').style.maxHeight = null;
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          body.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    // --- Popup: debe seleccionar talla ---
    var sizeAlert = document.querySelector('[data-bkl-size-alert]');
    var sizeAlertCloseEls = document.querySelectorAll('[data-bkl-size-alert-close]');

    function openSizeAlert() {
      if (!sizeAlert) return;
      sizeAlert.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (sizesBlock) {
        sizesBlock.classList.add('is-shaking');
        setTimeout(function () { sizesBlock.classList.remove('is-shaking'); }, 400);
      }
    }
    function closeSizeAlert() {
      if (!sizeAlert) return;
      sizeAlert.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    sizeAlertCloseEls.forEach(function (el) {
      el.addEventListener('click', closeSizeAlert);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeAlert && sizeAlert.classList.contains('is-open')) {
        closeSizeAlert();
      }
    });

    // --- Forzar checkout directo, interceptando ANTES que el script del tema ---
    if (form) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // Si el producto tiene tallas y ninguna está seleccionada, mostrar aviso
        if (hasSizes && (!hidden || !hidden.value)) {
          openSizeAlert();
          return;
        }

        if (addBtn) {
          addBtn.disabled = true;
          if (btnLabel) btnLabel.textContent = 'REDIRIGIENDO...';
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('No se pudo agregar al carrito');
            return res.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            if (btnLabel) btnLabel.textContent = 'ERROR, INTENTA DE NUEVO';
            if (addBtn) addBtn.disabled = false;
          });
      }, true);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bershk-pack"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bkp').forEach(function(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var form=root.querySelector('.bkp-form');
    var hidden=root.querySelector('[data-bkp-id]');
    var price=root.querySelector('[data-bkp-price]');
    var bar=root.querySelector('[data-bkp-barprice]');
    root.querySelectorAll('.bkp-size').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.hasAttribute('disabled'))return;
        root.querySelectorAll('.bkp-size').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
        if(hidden)hidden.value=b.dataset.id;
        if(price&&b.dataset.price)price.textContent=b.dataset.price;
        if(bar&&b.dataset.price)bar.textContent=b.dataset.price;
      });
    });
    var buy=root.querySelector('[data-bkp-buy]');
    if(buy&&form)buy.addEventListener('click',function(){form.requestSubmit?form.requestSubmit():form.submit();});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
